<!--
 * @Author: 李
 * @Date: 2021-12-02 14:47:44
 * @LastEditTime: 2021-12-24 15:42:56
 * @LastEditors: Please set LastEditors
 * @Description: 连接生成二维码
 * @FilePath: \yhb_-h5 - 副本\src\pages\qr\index1.vue
-->
<template>
  <div class="ypl-flex">
   
    <div  class="invitePosterPage flex">
       <img
      v-if="posterDataUrl"
      :src="posterDataUrl"
      class="poster-bg img"
      alt="邀请海报"
    />
      <div v-else id="poster" class="flex-row">
        <img
          class="poster-bg img"
          src="../../assets/bg1.jpg"
          alt="邀请海报背景"
        />
        <canvas class="qr" id="qrCode-canvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 这是邀请海报组件
 */
import QRCode from "qrcode";
import html2canvas from "html2canvas";

// import { link, upload } from "@/api/index";
// import { link } from "@/api/index";
export default {
  name: "poster",
  data() {
    return {
      posterDataUrl: "",
      qrCodeUrl: "",
      code: "",
      referKey: "",
    };
  },

  async mounted() {
    // 获取缓存信息
    this.qrCodeUrl = window.localStorage.getItem("jumpLink");
    this.createQRCode()
  },
  created() { },
  methods: {
    createQRCode() {
      //先用 QRCode 生成二维码 canvas，然后用 html2canvas 合成整张海报并转成 base64 显示出来
      let canvas = document.getElementById("qrCode-canvas");
      QRCode.toCanvas(canvas, this.qrCodeUrl, (error) => {
        if (error) {
          console.log(error);
        } else {
          //qrcode 生成的二维码会带有一些默认样式，需要调整下
          canvas.style.width = "155px";
          canvas.style.height = "155px";

          let poster = document.getElementById("poster");
          html2canvas(poster, {
            scale: 3, //缩放比例,默认为1
            dpi: 1000,
            allowTaint: false, //是否允许跨域图像污染画布
            useCORS: true,
            borderRadis: 10,
            backgroundColor: "#fff", //画布的背景色，默认为透明
          }).then((canvas) => {
            this.posterDataUrl = canvas.toDataURL();
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
} */

.invitePosterPage {
  width: 100vw;
  height: 100vh;
}
.poster-bg {
  width: 100vw;
  height: 100vh;
}
.flex-row {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.flex-row image {
  width: 100vw;
  height: 100vh;
}

.qr {
  position: absolute;
  top: 17vh;
  left: 15vw;
  width: 155px;
  height: 155px;
}
</style>
